import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa6";
import { getWhatsAppMessage, getWhatsAppLink } from "../data/whatsappContext";

/** Fixed positioning lives in the parent EngagementWidgetStack, which also stacks this alongside ChatbotWidget. */
export default function WhatsAppWidget() {
  const location = useLocation();
  const message = getWhatsAppMessage(location.pathname);
  const href = getWhatsAppLink(message);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with ZenFresh on WhatsApp"
      className="flex h-14 w-14 items-center justify-center rounded-full bg-teal-400 text-ocean-950 shadow-lg shadow-ocean-950/20 hover:scale-105 hover:bg-teal-300"
    >
      <FaWhatsapp className="h-7 w-7" />
    </a>
  );
}
